import { useQuery } from "convex/react";
import { api } from "@packages/backend/convex/_generated/api";
import { Id } from "@packages/backend/convex/_generated/dataModel";
import { useOutletContext, useParams, Link } from "react-router-dom";
import { PlayerContext } from "../../App";
import { useState } from "react";
export default function Episodes() {
  const { podcast_id } = useParams();
  const { set_player_episode_id } = useOutletContext<PlayerContext>();
  const [search, setSearch] = useState("");
  const episodes = useQuery(
    api.everwhz.episodes,
    podcast_id ? { podcast_id: podcast_id as Id<"podcast"> } : "skip",
  );
  const podcast = useQuery(
    api.everwhz.podcastTitle,
    podcast_id ? { id: podcast_id as Id<"podcast"> } : "skip",
  );
  return (
    <main className="content-page">
      <Link className="ep-link" to="/">
        ← Back to explore
      </Link>
      <div className="eyebrow">Podcast archive</div>
      <h1 className="headline">{podcast?.title || "Podcast episodes"}</h1>
      <p className="subline">{episodes?.length || 0} episodes</p>
      <div className="explorer-search">
        <input
          aria-label="Search this podcast"
          placeholder="Search this podcast…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="episodes">
        {episodes === undefined ? (
          <div className="empty" role="status">
            Loading episodes…
          </div>
        ) : (
          episodes
            .filter((e) =>
              (e.title || "").toLowerCase().includes(search.toLowerCase()),
            )
            .map((e) => (
              <article className="episode" key={e._id}>
                <div className="ep-date">
                  {e.years?.join(" · ") || "History dates not annotated"}
                </div>
                <h2 className="ep-title">{e.title || "Untitled episode"}</h2>
                <div className="ep-bottom">
                  <span className="ep-region">
                    {e.location?.join(" · ") || "Place not annotated"}
                  </span>
                  <button
                    className="ep-link"
                    disabled={!e.mp3_link}
                    onClick={() => set_player_episode_id(e._id)}
                  >
                    ▶ Play episode
                  </button>
                </div>
              </article>
            ))
        )}
      </div>
    </main>
  );
}
